<template>
  <batch-header
      :batch-id="batchId"
      :batch="batch"
      :can-write="canWrite"
      :supplierName="getSupplierName(batch.supplierId)"
      :regraterName="getRegrater(batch.regraterId)"
      :productName="getProduct(batch.productId)"
      :refresh-notes="headerRefreshNotes"
      @refreshed="refreshed"
      @editBatch="editBatch"/>

  <div v-if="nextStep === 'incoming'"
       class="row">
    <workflow-incoming :batch="activeBatch" :can-write="canWrite" @finishedWorkflowStep="finishedWorkflowStep"/>
  </div>

  <div v-if="nextStep === 'wet'"
       class="row">
    <bag-list :batch="batch" :bags="wetVessels ?? bags" :regraters="regraters" :workflow-status="0"
              :can-write="canWrite" @updatedVessels="updatedVessels"/>
  </div>

  <div v-if="nextStep === 'dry'"
       class="row">

    <div v-if="canWrite && (sentToSupplier || washedSentMail)" class="col-8 mt-3">
      <img class="opened" src="@/assets/images/icon-done.svg"/>
      Chargen-PDF an Lieferant gesendet
    </div>
    <div v-show="canWrite && sendToSupplier && !sentToSupplier" class="col-8">
      <button @click="sendEmail">Chargen-PDF an Lieferant senden</button>
    </div>
    <div v-if="sentToSupplierError" class="col-8 mt-3">
      <img class="opened" src="@/assets/images/icon-err.svg"/>
      {{ sentToSupplierError }}
    </div>

    <div v-if="wetVessels" class="w-100 mt-2">

      <h2>Nassbehälter</h2>
      <div class="mb-4">
        <ul class="output">
          <li
              v-for="bag in wetVessels"
              :key="bag.vesselId">
            <label class="col-3">{{ bag.number ? 'C-'+ bag.number : bag.uniqueNumber }}</label>
            {{ globalFunctions.parseNumber(bag.weight) }} kg <span class="float-right">{{ bag.dryerId && ' → '+ getDryerName(bag.dryerId) }}</span>
          </li>
        </ul>
      </div>

      <h1 class="mb-3">Trocknung</h1>
      <form class="row">
      <div class="input-group col-8 mb-3">
        <div class="input-group-prepend">
          <label class="input-group-text" for="dryerId">Trockner</label>
        </div>
        <select v-model="dryerId"
                @change="changedDryer"
                class="custom-select custom-select-lg" id="dryerId">
          <option value="0">Auswählen...</option>
          <option
              v-for="(name,id) in dryers"
              :key="id"
              :value="id">{{ name }}</option>
        </select>
      </div>
      </form>
    </div>

    <bag-list
        v-if="wetVessels && dryerId > 0"
        :batch="batch" :bags="bags" :workflow-status="dryingWFState" :workflow-state="batch.workflowState"
        :can-write="canWrite" :regraters="regraters" :dryingDryerId="dryerId" :wet-vessels="wetVessels"
        :drying-list="dryingList"
        @storedDrying="storedDrying" @finishedDrying="finishedDrying" @finishedWashing="finishedWashing"/>
    <bag-list
        v-else-if="!wetVessels"
        :batch="batch" :bags="bags" :can-write="canWrite"
        :regraters="regraters" :wetVesselId="wetVesselId" @finishedWashing="finishedWashing"
        :workflow-state="batch.workflowState" :workflow-status="batch.workflowStatus"/>

    <!--    <h2>Trocknen</h2>-->
    <!--    <form @submit.prevent="save" class="col-8">-->
    <!--&lt;!&ndash;      <input name="formName" value="dry" type="hidden"/>&ndash;&gt;-->
    <!--      <div class="input-group mb-3">-->
    <!--        <div class="input-group-prepend">-->
    <!--          <label class="input-group-text" for="dryWeight">Trockengewicht</label>-->
    <!--        </div>-->
    <!--        <input v-model="dryWeight" type="number" class="form-control form-control-lg"-->
    <!--               id="dryWeight" placeholder="">-->
    <!--        <div class="input-group-append">-->
    <!--          <span class="input-group-text">kg</span>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      <button type="submit">Speichern</button>-->
    <!--    </form>-->
  </div>

  <div v-if="nextStep === 'cleaning'"
       class="row">
    <workflow-cleaning :batch="batch" :can-write="canWrite" @finishedWorkflowStep="finishedWorkflowStep"/>
  </div>

  <div v-if="nextStep === 'filling'"
       class="row">

    <bag-list
        :batch="batch" :bags="dryVessels" :can-write="canWrite"
        :regraters="regraters" @finishedWorkflowStep="finishedWorkflowStep"
        :workflow-state="batch.workflowState" :workflow-status="batch.workflowStatus"/>
  </div>

  <div v-else-if="nextStep === 'stock' || nextStep === 'loading' || nextStep === 'completion'"
       class="row">
    <bag-list :batch="batch" :bags="bags" :regraters="regraters" :workflow-status="2" :can-write="canWrite"/>
  </div>

  <div v-if="(nextStep === 'stock' || nextStep === 'loading' || nextStep === 'completion') && batch.productId == 1"
      class="row">
    <h2>Dokumente</h2>
    <!-- PDF Lagerliste -->
    <div class="col-5">{{ isIntern && showBondnotePdf ? 'Warenbegleitschein': 'Lagerschein' }}</div>
    <div class="col-3 text-right">
      <api-pdf-link v-if="isIntern && showBondnotePdf" method="bondnote" :elementId="batch.uniqueId" label="PDF"
                    class="float-right"/>
      <api-pdf-link v-else method="stockslip" :elementId="batch.uniqueId" label="PDF" class="float-right"/>
    </div>
  </div>
  <div v-if="(nextStep === 'stock' || nextStep === 'loading' || nextStep === 'completion') && batch.productId == 1 && batchForRegrater(3)"
      class="row">
    <!-- todo: if alwera -->
    <div class="col-5 mt-2">Partieblatt {{ batch.number ?? '' }}</div>
    <div class="col-3 text-right mt-2">
      <api-pdf-link method="batchstockslip" :elementId="batch.uniqueId" label="PDF" class="float-right"/>
    </div>
  </div>
  <div v-if="(nextStep === 'storing' || nextStep === 'loading') && batch.productId > 1"
      class="row">
    <h2>Einlagerungsschein</h2>
    <div class="col-2">{{ batch.uniqueNumber }}</div>
    <div class="col-6 text-right">
      <api-pdf-link method="storeslip" :elementId="batch.uniqueId" label="PDF" class="float-right"/>
    </div>
  </div>

  <div v-if="nextStep === 'storing' || nextStep === 'loading' || nextStep === 'completion'"
       class="row">
    <!-- div v-if="showDryingNotePdf" class="col-5 mt-2">Trocknungsbegleitschein</div>
    <div v-if="showDryingNotePdf" class="col-3 mt-2 text-right">
      <api-pdf-link method="dryingnote" :elementId="batch.uniqueId" label="PDF" class="float-right"/>
    </div -->

    <!--PDF Warenbegleitschein-->
<!--    <div v-if="showBondnotePdf" class="d-flex w-100 mt-2">
      <div class="col-4">Warenbegleitschein</div>
      <div class="col-4 text-right">
      </div>
    </div>-->
    <!--    <div class="col-3 text-right">PDF versenden</div>-->
    <div v-if="canWrite && (sentToSupplier || driedSentMail)" class="col-8 mt-3">
      <img class="opened" src="@/assets/images/icon-done.svg"/>
      {{ stockslipLabel }} an Lieferant gesendet
    </div>
    <div v-if="canWrite && sendToSupplier && !sentToSupplier" class="col-8">
      <button @click="sendEmail">{{ stockslipLabel }} an Lieferant senden</button>
    </div>
    <div v-if="sentToSupplierError" class="col-8 mt-3">
      <img class="opened" src="@/assets/images/icon-err.svg"/>
      {{ sentToSupplierError }}
    </div>
  </div>
  <div v-if="loading"
      class="row">
    <h2 class="pt-3">Auslagerung</h2>
    <ul class="subnav w-100">
      <router-link
          v-for="data in loading"
          :key="data.loadingId"
          :to="{name: 'LoadingShow', params: {id: data.loadingId}}">
        <li>
          <label class="col-3">{{ data.deliverySlipNumber}}</label>
          <span>{{ globalFunctions.parseNumber(data.loadingWeight) }} kg</span>
        </li>
      </router-link>
    </ul>
    <ul class="output col-8 mb-0">
      <li><label class="col-3">Gesamt</label> {{ globalFunctions.parseNumber(getLoadingTotal()) }} kg</li>
      <li><label class="col-3">Rest</label> {{ globalFunctions.parseNumber(getStoreRest()) }} kg</li>
    </ul>
  </div>

  <div v-if="canWrite && (nextStep === 'storing' || nextStep === 'loading') && (batch.driedWeight || batch.productId > 1)"
       class="row">
    <div class="col-8">
      <router-link :to="{name:'LoadingShow', params: {id:0}}">
        <button>Verladen</button>
      </router-link>
    </div>
  </div>
  <div v-if="isAdmin && (nextStep === 'storing' || nextStep === 'loading')"
       class="row mt-3">
    <div class="col-8">
      <button
          @click="modalResetWorkflowStep = true"
          class="optional mt-2">Letzten Abschluss zurücksetzen</button>
    </div>
    <div class="col-8">
      <button
          @click="modalOpened = true"
          class="optional mt-2">Charge Abschließen</button>
    </div>
  </div>

  <app-btn-back class="pt-2" :router-link="backLink"/>
  <popup-batch-editor v-if="batchEditorOpened" :element="batchElement" :suppliers="suppliers"
                      :regraters="regraters" :quality-standards="qualityStandards"
                      @abortDialog="abortBatchEdit" @confirmDialog="saveBatchEdit"></popup-batch-editor>

  <app-modal-dialog v-if="modalOpened" @abortDialog="abortDialog" @confirmDialog="confirmDialog">
    <h1>Chargen-Abschluss bestätigen</h1>
    <div class="w-100">{{ modalText }}</div>
    <div class="w-100"><strong>{{ modalElement }}</strong></div>
  </app-modal-dialog>

  <app-modal-dialog v-if="modalResetWorkflowStep" @abortDialog="abortResetWFS" @confirmDialog="confirmResetWFS">
    <h1>Letzten Abschluss zurücksetzen</h1>
    <div class="w-100">{{ modalText }}</div>
    <div class="w-100"><strong>{{ modalElement }}</strong></div>
  </app-modal-dialog>

</template>

<script>
import { inject } from 'vue'
import BatchHeader from "@/components/BatchHeader.vue";
import WorkflowIncoming from "@/components/WorkflowIncoming.vue";
import BagList from "@/components/BagList";
import ApiPdfLink from "@/components/ApiPdfLink";
import PopupBatchEditor from "@/components/PopupBatchEditor";
import AppModalDialog from "@/components/AppModalDialog";
import dayjs from "dayjs";
import WorkflowCleaning from "@/components/WorkflowCleaning.vue";

export default {
  name: "PageBatchShow",
  components: {
    WorkflowCleaning,
    BatchHeader, WorkflowIncoming, PopupBatchEditor, BagList, ApiPdfLink, AppModalDialog
  },
  data() {
    return {
      batchId: 0,
      activeBatch: {},
      lastStep: '',
      step: '',
      dryWeight: null,
      backLink: '',
      sendToSupplier: false,
      sentToSupplier: false,
      sentToSupplierError: '',
      batchElement: null,
      batchEditorOpened: false,
      washedSentMail: false,
      driedSentMail: false,
      stockslipLabel: "Lagerschein",
      wetVessels: null,
      wetVesselId: 0,
      wetVesselData: null,
      dryingWFState: 1,
      dryerId: 0,
      globalFunctions: inject('globalFunctions'),
      modalOpened: false,
      modalText: '',
      modalElement: '',
      modalResetWorkflowStep: false,
      dryingList: null,
      headerRefreshNotes: false,
    }
  },
  props: {
    id: {
      required: true,
      type: String
    }
  },
  async created() {
    this.setBatchId(this.id)  

    // console.log('------------------created')
    await this.$store.dispatch('getItemList', {entityName: 'batch'})
    await this.$store.dispatch('getItemsByParent', {
      entityName: 'vessel',
      parentEntity: 'batch',
      parentId: this.batchId
    })
    await this.$store.dispatch('getItemList', {entityName: 'supplier'})
    await this.$store.dispatch('getItemList', {entityName: 'regrater'})
    await this.$store.dispatch('initItems', {entityName: 'setting'})
    await this.$store.dispatch('getItemList', {entityName: 'product'})
    // console.log('------------------created done')

    const batch = this.getBatch()
    if (batch) {
      const supplier = this.getSupplier(batch.supplierId)

      if (batch.workflowState < 50) await this.getWetVessels()
      if (batch.workflowState > 30 && batch.workflowState < 60) await this.getDryingList()

      if (parseInt(batch['washedSentMail']))
        this.washedSentMail = true
      if (parseInt(batch['driedSentMail']))
        this.driedSentMail = true
      if (supplier['email'])
        this.sendToSupplier = true

      //this.batch = batch
    }
    if (this.batch.productId > 1)
      this.stockslipLabel = "Einlagerungsschein"
    else if (this.showBondnotePdf)
      this.stockslipLabel = "Warenbegleitschein"

    if (batch.workflowState >= 55) { // loading+
      await this.$store.dispatch('getItemsByParent', {
        entityName: 'loading',
        parentEntity: 'batch',
        parentId: this.batchId
      })
    } else if (batch.workflowState == 30 && this.dryingList) { // drying
      // console.log('*** dryingList on wfState 30', this.dryingList)
      const unfinishedDryer = this.dryingList.find(drying => drying.workflowStatus == 1)
      if (unfinishedDryer)
        this.dryerId = unfinishedDryer.dryerId
    }
  },
  async beforeMount() {
    // console.log('------------------beforeMount')
    // console.log('------------------beforeMount end')
  },
  async mounted() {
    // console.log('------------------mounted')
    // load batch washed image
    const batchData = await this.$store.dispatch('getItem', {name: 'batch', id: this.batchId})
    const batch = this.getBatch()

    if (batchData && batchData['washedPicture1'])
      batch['washedPicture1'] = batchData['washedPicture1']

    if (batchData) this.activeBatch = {...batch, ...batchData}
    // console.log('------------------mounted end')
  },
  computed: {
    suppliers() {
      return this.$store.state.supplier
    },
    regraters() {
      return this.$store.state.regrater
    },
    qualityStandards() {
      return this.$store.state.qualityStandards
    },
    dryers() {
      return this.$store.getters.dryers
    },
    dryersAmount() {
      return this.$store.getters.dryersAmount
    },
    products() {
      return this.$store.getters.products
    },
    canWrite() {
      return this.$store.getters.canWrite
    },
    isAdmin() {
      return this.$store.getters.isAdmin
    },
    isIntern() {
      return this.$store.getters.isIntern
    },
    showBatchTime() {
      return this.$store.getters.batchTime
    },
    showBatchSampleNumber() {
      return this.$store.getters.batchSampleNumber
    },
    showBondnotePdf() {
      //return false
      return this.$store.getters.bondnotePdf
    },
    showDryingNotePdf() {
      return this.$store.getters.dryingNotePdf
    },
    getIncomingLocationNames() {
      return this.$store.getters.incomingLocationNames
    },
    batch() {
      let batch = this.getBatch()
      // console.log('*** computed batch', batch)
      if (batch) {
        if (batch.qualityStandard > 0) {
          const object = this.$store.state.qualityStandards.find(quality => quality.id == batch.qualityStandard)
          if (object) {
            batch.qualityStandardId = batch.qualityStandard
            batch.qualityStandard = object.name
          }
        }
      } else
        batch = {}

      return batch
    },
    bags() {
      const batch = this.getBatch()
      if (batch && batch.vessel) return batch.vessel
      else return []
      /* else {
        const batch = this.$store.state.batch.find(batch => batch.batchId == this.batchId)
        if (batch && batch.vessel) return batch.vessel
        else
          return []
      } */
    },
    dryVessels() {
      const vessels = this.$store.state.batch.find(batch => batch.batchId == this.batchId).vessel
      if (vessels) {
        return vessels.filter(vessel => vessel.workflowState == 2)
      }
      return []
    },
    nextStep() {
      const batch = this.batch ?? this.getBatch()

      if (batch) {
        return this.getNextStep(batch)
      }
      return ''
    },
    loading() {
      const batch = this.$store.state.batch.find(batch => batch.batchId == this.batchId)
      if (batch && batch.loading && batch.loading.length)
        return batch.loading

      return null
    },
  },
  methods: {
    // batch() {
    //   return this.getBatch()
    // },
    // batch() {
    //   let batch = this.getBatch()
    //   // console.log('*** methods batch', batch)
    //   if (batch) {
    //     if (batch.qualityStandard > 0) {
    //       const object = this.$store.state.qualityStandards.find(quality => quality.id === batch.qualityStandard)
    //       batch.qualityStandard = object.name
    //     }
    //   } else
    //     batch = {}
    //
    //   return batch
    // },
    getBatch() {
      console.log('getbatch (batchShow)', this.activeBatch, this.id, this.$store.state.batch)
      return this.activeBatch ?? this.$store.state.batch.find(batch => batch.batchId == this.batchId)
    },
    getNextStep(batch) {
      console.log('*** getNextStep', batch.workflowState)
      if (batch) {
        /*/ get next step via product
        const product = this.$store.state.product.find(product => product.productId == batch.productId)
        const workflow = JSON.parse(product.workflow)
        const nextWorkflowState = workflow.steps.find(item => item > batch.workflowState)
         */
        switch (batch.workflowState) {
          case 10:
            this.step = 'incoming'
            this.backLink = 'IncomingPage'
            break;
          case 20:
            this.step = 'wet'
            this.backLink = 'IncomingPage'
            break;
          case 30:
            this.step = 'dry'
            this.backLink = 'DryingPage'
            break;
          case 40:
            this.step = 'cleaning'
            this.backLink = 'DryingPage'
            break;
          case 50:
            if (!this.batch.workflowStatus)
              batch.workflowStatus = 1

            this.step = 'filling'
            this.backLink = 'DryingPage'
            break;
          case 55:
            this.step = 'storing'
            this.backLink = 'StockPage'
            break;
          case 60:
            this.step = 'loading'
            this.backLink = 'StockPage'
            break;
          case 80:
            this.step = 'completion'
            this.backLink = 'Home'
            break;
        }
        /*
        if (batch.washedWeight === null) {
          this.step = 'wet'
          this.backLink = 'IncomingPage'
        } else if (!batch.driedWeight) {
          this.step = 'dry'
          this.backLink = 'DryingPage'
        } else if (!batch.vessel) {
          this.step = 'stock'
          this.backLink = 'DryingPage'
        } else if (!batch.loaded) {
          this.step = 'loading'
          this.backLink = 'StockPage'
        }
        */

        console.log('*** nextStep', this.step, batch.workflowState)

        if (this.step !== this.lastStep) {
          this.sentToSupplier = false
          this.lastStep = this.step
        }

        return this.step
      }
    },
    getSupplier(id) {
      if (!id || !this.$store.state.supplier) return ''
      const item = this.$store.state.supplier.find(item => item.contactId === id)
      //TODO if item missing: request from server by two credentials to validate
      if (!item) return null
      return item
    },
    getSupplierName(id) {
      const item = this.getSupplier(id)

      if (!item) return '–'
      return item.name
    },
    getRegrater(id) {
      if (!id || !this.$store.state.regrater) return '–'
      const item = this.$store.state.regrater.find(item => item.contactId === id)
      if (!item) return '–'
      return item.name
    },
    getProduct(id) {
      if (!id || !this.$store.state.product) return '–'
      const item = this.$store.state.product.find(item => item.productId === id)
      if (!item) return '–'
      return item.name
    },
    save() {
      let batch = {}

      switch (this.step) {
        case 'wet':
          console.log('step wet')
          // store vessel with workflow state washed and wet weight
          break
        case 'dry':
          batch = {
            dryWeight: this.dryWeight
          }
          this.$store.dispatch('updateBatch', {id: this.batchId, batch})
          this.dryWeight = null;
          this.step = 'stock'
          break
      }
    },
    setBatchId(id) {
      const pos = id.indexOf('.')
      if (pos >= 0)
        id = id.substring(0, pos)
      if (id.indexOf('CH') === 0)
        id = id.substring(2)

      this.batchId = id
    },
    async sendEmail() {
      // console.log('sendMail')
      let type = this.step === 'dry' ? 'batchslip' : 'stockslip';
      if (this.isGrain())
        type = 'storeslip'

      const response = await this.$store.dispatch('sendEmail', {
        type: type,
        uid: this.batch.uniqueId
      })
      this.sentToSupplier = false

      if (response.success) {
        if (this.step === 'dry')
          this.washedSentMail = true
        else
          this.driedSentMail = true

        this.sentToSupplier = true
      } else {
        if (this.step === 'dry')
          this.washedSentMail = false
        else
          this.driedSentMail = false

        this.sentToSupplier = false

        this.sentToSupplierError = response.err || 'Es ist ein Fehler aufgetreten.'
      }
      // console.log(response)
    },
    // batch popup editor
    editBatch(batch) {
      this.batchElement = batch
      this.batchEditorOpened = true
    },
    abortBatchEdit() {
      this.batchElement = null
      this.batchEditorOpened = false
    },
    async saveBatchEdit({id, supplierId, regraterId, qualityStandard, breed, batchDate, batchTime, incomingLocationId, sampleNumber}) {
      const data = {
        supplierId, regraterId, qualityStandard, breed, batchDate
      }
      if (this.showBatchTime)
        data.batchTime = batchTime
      if (this.getIncomingLocationNames)
        data.incomingLocationId = incomingLocationId
      if (this.showBatchSampleNumber)
        data.sampleNumber = sampleNumber

      const response = await this.$store.dispatch('cruItem',
          {name: 'batch', id, data: data})

      if (response && response.success === true) {
        const object = this.$store.state.qualityStandards.find(quality => quality.id == qualityStandard)
        const customParseFormat = require('dayjs/plugin/customParseFormat')
        dayjs.extend(customParseFormat)

        this.batchElement = {
          ...this.batchElement,
          supplierId,
          regraterId,
          qualityStandardId: qualityStandard,
          breed,
          qualityStandard: object.name,
          batchDate: dayjs(batchDate, 'DD.MM.YYYY', true).format('YYYY-MM-DD'),
          batchTime,
        }
        this.abortBatchEdit()
        // console.log(this.getNextStep(this.getBatch()))
        if (this.getNextStep(this.getBatch()) === 'dry') {
          // reload vessels
          this.$store.dispatch('getItemsByParent', {
            entityName: 'vessel', parentEntity: 'batch',
            parentId: this.batch.batchId, method: 'dried'
          })
        }
      }
    },
    async getWetVessels() {
      console.log('getWetVessels (batchShow)', this.wetVessels)
      if (!this.wetVessels) {
        const result = await this.$store.dispatch('getItemsByParent', {
          entityName: 'vessel', parentEntity: 'batch',
          parentId: this.batch.batchId, method: 'washed',
          returnData: true
        })
        this.wetVessels = result
      }
      console.log('wetVessels', this.wetVessels)
      return this.wetVessels
    },
    async getDryingList() {
      console.log('getDryingList (batchShow)')
      this.dryingList = await this.$store.dispatch('getItemsByParent', {
        entityName: 'drying', parentEntity: 'batch', parentId: this.batch.batchId,
        returnData: true
      })
    },
    async changedDryer() {
      console.log('changedDryer: dryingData, dryingList', this.dryingData, this.dryingList)
      if (this.dryingList)
        this.dryingData = this.dryingList.find(item => item.dryerId == this.dryerId)
      console.log('changedDryer: dryingData', this.dryingData)
      if (this.dryingData)
        this.dryingWFState = this.dryingData.workflowStatus > 1 ? 2 : 1
      else // default state: started
        this.dryingWFState = 1
    },
    finishedWashing({workflowState}) {
      console.log('finishedWashing',workflowState)
      this.getWetVessels()
      if (workflowState) {
        this.batch.workflowState = workflowState
        if (workflowState == 30)
          this.batch.workflowStatus = 1
      }
      this.headerRefreshNotes = true
    },
    storedDrying() {
      this.getDryingList()
    },
    async finishedDrying({driedWeight,workflowState}) {
      console.log('finishedDrying',driedWeight,workflowState)
      await this.getDryingList()
      console.log('dryingList',this.dryingList)

      if (workflowState) {
        if (workflowState == 50) {
          // check if all vessels are finished
          let finishedAll = true
          for (let item of this.dryingList) {
            if (item.workflowStatus < 3) {
              finishedAll = false
              break
            }
          }
          if (finishedAll) {
            // finish workflow step drying
            const data = {
              finishWorkflowStep: workflowState,
            }
            const response = await this.$store.dispatch('cruItem',
                {name: 'batch', id: this.batch.batchId, data})

            if (response && response.success) {
              this.finishedWorkflowStep({data: {workflowState: response.workflowState}})
            }
          }
        }
        this.batch.workflowState = workflowState
      } else {
        let dryingListItem = this.dryingList.find(item => item.dryerId == this.dryerId)
        dryingListItem.driedWeight = driedWeight
        dryingListItem.workflowStatus = 3;
        this.dryingWFState = 2;
      }
      this.headerRefreshNotes = true
    },
    finishedWorkflowStep({data}) {
      console.log('finishedWorkflowStep',data.workflowState)
      if (data.workflowState) {
        const batch = this.getBatch()

        this.activeBatch = {...batch, ...data}

        this.getNextStep(batch)
      }
      this.headerRefreshNotes = true
    },
    updatedVessels({data}) {
      console.log('updatedVessels (batchShow)',data)
      if (data) {
        this.activeBatch.vessel = data
        this.wetVessels = data
      }
    },
    getDryerName(id) {
        return id ? this.dryers[id] : ''
    },
    async completeBatch() {
      const data = {
        workflowState: 80, // completion
        workflowStatus: 1, // started
      }
      const response = await this.$store.dispatch('cruItem',
          {name: 'batch', id: this.batch.batchId, data})

      if (response && response.success) {
        this.finishedWorkflowStep({data: {workflowState: 80}})
        this.abortDialog()
      }
    },
    abortDialog() {
      this.modalOpened = false
    },
    async confirmDialog() {
      await this.completeBatch()
    },
    abortResetWFS() {
      this.modalResetWorkflowStep = false
    },
    async confirmResetWFS() {
      const id = this.batch.batchId
      const data = {
        'workflowState': this.batch.workflowState,
        'resetWorkflowStep': true,
      }
      const response = await this.$store.dispatch('cruItem',
          {name: 'batch', id, data: data})

      if (response && response.success) {
        this.finishedWorkflowStep({data: {workflowState: response.workflowState}})
        this.abortResetWFS()
      }
    },

    parseNumber(number) {
      if (parseInt(number) != number)
        number = parseFloat(number)
      else
        number = parseInt(number)

      return number.toLocaleString('de-DE')
    },
    isGrain() {
      return this.getBatch().productId > 1
    },
    getLoadingTotal() {
      let total = 0
      for (const loading of this.loading) {
        total += loading.loadingWeight
      }
      return total
    },
    getStoreRest() {
      const store = this.activeBatch.tareWeight - (this.activeBatch.tareWeight * this.activeBatch.dockage / 100)
      return store - this.getLoadingTotal()
    },
    batchForRegrater(regraterType) {
      // validate if batch or vessels is for regrater type
      let regraterIds = []
      const batch = this.$store.state.batch.find(batch => batch.batchId == this.batchId)

      if (!batch) // for to early method calls on rendering
        return false

      regraterIds.push(batch.regraterId)
      if (batch.vessel) {
        for (const vessel of batch.vessel) {
          if (vessel.regraterId)
            regraterIds.push(vessel.regraterId)
        }
      }

      for (const regraterId of regraterIds) {
        const regrater = this.$store.state.regrater.find(item => item.contactId === regraterId)

        if (!regrater)
          continue

        if (this.$store.state.regrater.find(item => item.contactId === regraterId).regraterType == regraterType)
          return true
      }

      return false
    },
    refreshed({what}) {
      switch (what) {
        case 'notes':
            this.headerRefreshNotes = false
            break;
      }
    },
  }
}
</script>

<style scoped>
.opened {
  margin-top: -4px
}

button.edit {
  float: left;
}
</style>